import { render, staticRenderFns } from "./UsuarioPerfil.vue?vue&type=template&id=59814dd9&"
import script from "./UsuarioPerfil.vue?vue&type=script&lang=js&"
export * from "./UsuarioPerfil.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioPerfil.vue?vue&type=style&index=0&id=59814dd9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports